//Polyfill
import "core-js";
import jQuery from "jquery";
const $ = jQuery; // ドルマークに参照を代入(慣習的な $ を使うため)

//Can't resolve 'regenerator-runtime/runtime'が表示されたとき(async awaitを使う場合など)
//import  regeneratorRuntime  from  "regenerator-runtime" ;

//bootstrapのmodalを読み込み
// import "/node_modules/bootstrap/js/dist/modal";


$(function () {
  var isAnimating = false;

  function toggleMenu() {
    if (isAnimating) {
      return;
    }
    isAnimating = true;
    $(".sp-nav, .header-sp_btn, .close").toggleClass("open");
    setTimeout(function() {
      isAnimating = false;
    }, 300); // アニメーションの時間に合わせて設定してください
  }

  $(".header-sp_btn").click(function() {
    toggleMenu();
  });
  $(".close").click(function() {
    $(".sp-nav, .header-sp_btn").removeClass("open");
  });

  //aタグが外部リンクの場合はtargetを_blankにする
  $("a").each(function() {
    var href = $(this).attr("href");
    if (href && /^https?:\/\//i.test(href) && !href.startsWith(window.location.origin)) {
      $(this).attr("target", "_blank");
    }
  });
});

const swiper = new Swiper(".staffSwiper", {
  slidesPerView: 1,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 30
    },
  },
  loop: true,
  autoplay: {
    delay: 4000
  },
});

const swiper = new Swiper(".wamodernSwiper", {
  slidesPerView: 1.2,
  spaceBetween: 30,
  centeredSlides: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 1.5,
      spaceBetween: 60,
    },
  },
  loop: true,
  autoplay: {
    delay: 2500
  },
});